import { getRecentTransactions } from "../../_helpers/creditCard.helper";
import { accountTypesConstants, creditCardConstants } from "../_constants";

const INITIAL_CREDIT_CARD_DATA_STATE = {
  isCreditCardStatementLoading: false,
  creditCardStatementDetails: {},
  isCreditCardTransactionListLoading: false,
  creditCardTransactionListFail: false,
  creditCardTransactionList: {
    list: [],
  },
  creditCardRecentTransactionListFail: false,
  creditCardRecentTransactionList: {
    list: [],
  },
  isCreditCardStatementListLoading: false,
  creditCardStatementListFail: false,
  creditCardStatementList: {
    list: [],
  },
  isCreditCardStatementDetailsLoading: false,
  creditCardStatementDetailListFail: false,
  creditCardStatementDetailList: {
    dueDate: null,
    minimumAmount: null,
    openingBalance: null,
    totalOutstanding: null,
    list: [],
  },
  isSupplementaryCardDetailsLoading: false,
  supplementaryCardDetails: {},
  isDebitCardDetailsLoading: false,
  debitCardDetails: {},
  isDebitCardTransactionHistoryLoading: false,
  debitCardTransactionHistory: {
    list: [],
  },
};

export function creditCardReducer(
  state = INITIAL_CREDIT_CARD_DATA_STATE,
  action,
) {
  switch (action.type) {
    case creditCardConstants.CREDIT_CARD_CASHBACK_DETAILS_REQUEST:
      return {
        ...state,
        isCreditCardStatementLoading: true,
        creditCardStatementDetails: {},
      };
    case creditCardConstants.CREDIT_CARD_CASHBACK_DETAILS_COMPLETE:
      return {
        ...state,
        creditCardStatementDetails:
          action?.payload?.data?.creditCardStatementDetailsDto,
        isCreditCardStatementLoading: false,
      };

    case creditCardConstants.CREDIT_CARD_CASHBACK_DETAILS_ERROR:
      return {
        ...state,
        isCreditCardStatementLoading: false,
        creditCardStatementDetails: {},
      };

    case creditCardConstants.CREDIT_CARD_TRANSACTION_LIST_REQUEST:
      if (
        action?.payload?.billingStatus ===
        accountTypesConstants.BILLING_STATUS_RECENT
      ) {
        return {
          ...state,
          isCreditCardTransactionListLoading: true,
          creditCardTransactionListFail: false,
          creditCardRecentTransactionListFail: false,
          creditCardTransactionList: {
            ...state?.creditCardTransactionList,
            list: [],
          },
          creditCardRecentTransactionList: {
            ...state?.creditCardTransactionList,
            list: [],
          },
        };
      } else {
        return {
          ...state,
          isCreditCardTransactionListLoading: true,
          creditCardTransactionListFail: false,
          creditCardTransactionList: {
            ...state.creditCardTransactionList,
            list: [],
          },
        };
      }
    case creditCardConstants.CREDIT_CARD_TRANSACTION_LIST_COMPLETE:
      if (
        action?.payload?.billingStatus ===
        accountTypesConstants.BILLING_STATUS_RECENT
      ) {
        return {
          ...state,
          creditCardTransactionList: {
            ...state?.creditCardTransactionList,
            list: action.payload.data.creditCardTransactionList,
          },
          creditCardRecentTransactionList: {
            ...state?.creditCardTransactionList,
            list: getRecentTransactions(
              action?.payload?.data?.creditCardTransactionList,
            ),
          },
          isCreditCardTransactionListLoading: false,
        };
      } else {
        return {
          ...state,
          creditCardTransactionList: {
            ...state.creditCardTransactionList,
            list: action?.payload?.data?.creditCardTransactionList,
          },
          isCreditCardTransactionListLoading: false,
        };
      }

    case creditCardConstants.CREDIT_CARD_TRANSACTION_LIST_ERROR:
      if (
        action?.payload?.billingStatus ===
        accountTypesConstants.BILLING_STATUS_RECENT
      ) {
        return {
          ...state,
          isCreditCardTransactionListLoading: false,
          creditCardTransactionListFail: true,
          creditCardRecentTransactionListFail: true,
          creditCardTransactionList: {
            ...state.creditCardTransactionList,
            list: [],
          },
          creditCardRecentTransactionList: {
            ...state.creditCardTransactionList,
            list: [],
          },
        };
      } else {
        return {
          ...state,
          isCreditCardTransactionListLoading: false,
          creditCardTransactionListFail: true,
          creditCardTransactionList: {
            ...state.creditCardTransactionList,
            list: [],
          },
        };
      }

    case creditCardConstants.CREDIT_CARD_STATEMENT_LIST_REQUEST:
      return {
        ...state,
        isCreditCardStatementListLoading: true,
        creditCardStatementListFail: false,
        creditCardStatementList: {
          ...state.creditCardStatementList,
          list: [],
        },
      };

    case creditCardConstants.CREDIT_CARD_STATEMENT_LIST_COMPLETE:
      return {
        ...state,
        creditCardStatementList: {
          ...state?.creditCardStatementList,
          list: action?.payload?.data?.statementList,
        },
        isCreditCardStatementListLoading: false,
      };

    case creditCardConstants.CREDIT_CARD_STATEMENT_LIST_ERROR:
      return {
        ...state,
        isCreditCardStatementListLoading: false,
        creditCardStatementListFail: true,
        creditCardStatementList: {
          ...state?.creditCardStatementList,
          list: [],
        },
      };

    case creditCardConstants.CREDIT_CARD_STATEMENT_DETAILS_REQUEST:
      return {
        ...state,
        isCreditCardStatementDetailsLoading: true,
        creditCardStatementDetailListFail: false,
        creditCardStatementDetailList: {
          ...state?.creditCardStatementDetailList,
          dueDate: null,
          minimumAmount: null,
          openingBalance: null,
          totalOutstanding: null,
          list: [],
        },
      };

    case creditCardConstants.CREDIT_CARD_STATEMENT_DETAILS_COMPLETE:
      return {
        ...state,
        creditCardStatementDetailList: {
          ...state?.creditCardStatementDetailList,
          dueDate: action?.payload?.data?.dueDate ?? null,
          minimumAmount: action?.payload?.data?.minimumAmount ?? null,
          openingBalance: action?.payload?.data?.openingBalance ?? null,
          totalOutstanding: action?.payload?.data?.totalOutstanding ?? null,
          list: Array.isArray(action?.payload?.data?.detailsList)
            ? action?.payload?.data?.detailsList
            : [],
        },
        isCreditCardStatementDetailsLoading: false,
      };

    case creditCardConstants.CREDIT_CARD_STATEMENT_DETAILS_ERROR:
      return {
        ...state,
        isCreditCardStatementDetailsLoading: false,
        creditCardStatementDetailListFail: true,
        creditCardStatementList: {
          ...state?.creditCardStatementDetailList,
          list: [],
          dueDate: null,
          minimumAmount: null,
          openingBalance: null,
          totalOutstanding: null,
        },
      };
    case creditCardConstants.CREDIT_CARD_SUPPLEMENTARY_DETAILS_REQUEST:
      return {
        ...state,
        isSupplementaryCardDetailsLoading: true,
        supplementaryCardDetails: {},
      };
    case creditCardConstants.CREDIT_CARD_SUPPLEMENTARY_DETAILS_COMPLETE:
      return {
        ...state,
        supplementaryCardDetails: action.payload.data.cardDetails,
        isSupplementaryCardDetailsLoading: false,
      };

    case creditCardConstants.CREDIT_CARD_SUPPLEMENTARY_DETAILS_ERROR:
      return {
        ...state,
        isSupplementaryCardDetailsLoading: false,
        supplementaryCardDetails: {},
      };

    case creditCardConstants.DEBIT_CARD_DETAILS_REQUEST:
      return {
        ...state,
        isDebitCardDetailsLoading: true,
        debitCardDetails: {},
      };

    case creditCardConstants.DEBIT_CARD_DETAILS_COMPLETE:
      return {
        ...state,
        debitCardDetails: action?.payload?.data?.debitCardDetails,
        isDebitCardDetailsLoading: false,
      };

    case creditCardConstants.DEBIT_CARD_DETAILS_ERROR:
      return {
        ...state,
        isDebitCardDetailsLoading: false,
        debitCardDetails: {},
      };

    case creditCardConstants.DEBIT_CARD_TRANSACTION_HISTORY_REQUEST:
      return {
        ...state,
        isDebitCardTransactionHistoryLoading: true,
        debitCardTransactionHistory: {
          ...state?.debitCardTransactionHistory,
          list: [],
        },
      };

    case creditCardConstants.DEBIT_CARD_TRANSACTION_HISTORY_COMPLETE:
      return {
        ...state,
        debitCardTransactionHistory: {
          ...state.debitCardTransactionHistory,
          list: action?.payload?.data?.debitCardTransactionHistory || [],
        },
        isDebitCardTransactionHistoryLoading: false,
      };

    case creditCardConstants.DEBIT_CARD_TRANSACTION_HISTORY_ERROR:
      return {
        ...state,
        isDebitCardTransactionHistoryLoading: false,
        debitCardTransactionHistory: {
          ...state?.debitCardTransactionHistory,
          list: [],
        },
      };
  }

  return state;
}
